<!-- src/layouts/Navbar.vue -->
<template>
  <nav class="navbar navbar-custom navbar-fixed-top" role="navigation">
    <div class="container">
      <!-- Brand and toggle for mobile -->
      <div class="navbar-header">
        <!-- v3 toggler markup (won't work without JS; fine if you don't need collapsible mobile now) -->
        <!-- <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#main-navbar">
          Menu <i class="fa fa-bars"></i>
        </button> -->
        <RouterLink class="navbar-brand" to="/">Organza</RouterLink>
      </div>

      <div id="main-navbar" class="collapse navbar-collapse">
        <ul class="nav navbar-nav navbar-right">
          <li><RouterLink to="/">Home</RouterLink></li>
          <li><RouterLink to="/company/all">Org Chart</RouterLink></li>
          <li><RouterLink to="/wiki">Wiki</RouterLink></li>
          <li v-if="auth.isAdminRole">
            <RouterLink to="/admin">Admin</RouterLink>
          </li>
          <li v-if="auth.isAdminRole">
            <RouterLink to="/admin/users">Users</RouterLink>
          </li>
          <li v-if="auth.permission === 'employee'">
            <RouterLink to="/employee">Employee</RouterLink>
          </li>
          <li>
            <button v-if="auth.isLoggedIn" class="btn btn-primary navbar-btn" @click="logout">
              Logout
            </button>
            <RouterLink v-else class="btn btn-danger navbar-btn" to="/login">
              Login
            </RouterLink>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { RouterLink } from 'vue-router'
import { useAuthStore } from '@/store/auth'
const auth = useAuthStore()
const logout = () => auth.logout()
</script>

<style scoped>
/* Keep this tiny; your legacy CSS and bootstrap do the heavy lifting */
.navbar { margin-bottom: 0; }
</style>
